import css from "standard/css";

const style = css`
  .activityCompleted {
    align-items: center;
    background-color: #FB601D;
    border: none;
    border-bottom: 2px solid #ff7d45;
    border-radius: 12px;
    box-shadow: 0 10px 0 #cd511c;
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    gap: var(--spacing-nano);
    height: 50px;
    justify-content: center;
    line-height: 1;
    padding: 0 var(--spacing_inset-md);
  }

  .activityCompleted:active {
    box-shadow: none; 
    transform: translateY(5px);
  }
`;

export default style;
